import { EBuilderChatActionTypes, TBuilderChatActions } from '../../actions/builderChat';
import { IBuilderChatState } from '../../types/builderChatState/builderChat';

const initialState: IBuilderChatState = {
  isOpened: false,
};

export function builderChatReducer(
  state: IBuilderChatState = initialState,
  action: TBuilderChatActions,
): IBuilderChatState {
  switch (action.type) {
    case EBuilderChatActionTypes.OpenChat:
      return {
        ...state,
        isOpened: true,
        chatContact: action.payload,
      };

    case EBuilderChatActionTypes.CloseChat:
      return {
        ...state,
        isOpened: false,
        chatContact: undefined,
      };

    case EBuilderChatActionTypes.SetBuilderChatButtonClicked:
      return {
        ...state,
        isButtonClicked: true,
      };

    default:
      return state;
  }
}
